import type { MatchReaction } from "../services/matchesApi";

export const MATCH_REACTION_STORAGE_KEY = "hdg_match_reaction_overrides";
export const MATCH_REACTION_EVENT = "hdg-match-reaction-updated";

export type MatchReactionOverrideMap = Record<string, MatchReaction>;

export const getMatchReactionStorageKey = (userId?: string | null): string | null => {
  if (!userId) return null;
  return `${MATCH_REACTION_STORAGE_KEY}:${userId}`;
};

export const readMatchReactionOverrides = (
  userId?: string | null
): MatchReactionOverrideMap => {
  if (typeof window === "undefined") return {};
  const storageKey = getMatchReactionStorageKey(userId);
  if (!storageKey) return {};
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) return {};
    return JSON.parse(raw) as MatchReactionOverrideMap;
  } catch {
    return {};
  }
};

export const storeMatchReactionOverride = (
  profileId: string,
  reaction: MatchReaction,
  userId?: string | null
) => {
  if (!profileId || typeof window === "undefined") return;
  const storageKey = getMatchReactionStorageKey(userId);
  if (!storageKey) return;
  try {
    const existing = readMatchReactionOverrides(userId);
    const next = { ...existing, [profileId]: reaction ?? null };
    window.localStorage.setItem(storageKey, JSON.stringify(next));
  } catch {
    // Ignore storage failures
  }
};

export const broadcastMatchReactionUpdate = (
  profileId: string,
  reaction: MatchReaction,
  userId?: string | null
) => {
  if (!profileId) return;
  storeMatchReactionOverride(profileId, reaction, userId);
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(MATCH_REACTION_EVENT, {
        detail: { profileId, reaction },
      })
    );
  }
};
